import React from "react";
import { Box, Text } from "@radix-ui/themes";
import styles from "./styles.module.scss";

const Grid = ({ 
  items = [], 
  columns = 3,
  backgroundColor = "var(--color-primary)",
  gap = "20px"
}) => {
  return (
    <Box className={styles.section} style={{ backgroundColor }}>
      <div 
        className={styles.grid}
        style={{
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: gap
        }}
      >
        {items.map((item, index) => (
          <div key={index} className={styles.gridItem}>
            <img 
              src={item.image} 
              alt={item.text} 
              className={styles.image}
            />
            <div className={styles.overlay}>
              <Text className={styles.text}>{item.text}</Text>
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
};

export default Grid;
